import { ABDL_SERVICES_PAGE_URL, ABOUT_PAGE_URL, CONTACT_PAGE_URL, DOMINATION_SERVICES_PAGE_URL, HOME_PAGE_URL } from '../Routes';

export const FooterLinksArray = [
    {
        name: 'Home',
        route: HOME_PAGE_URL
    },
    {
        name: 'Contact',
        route: CONTACT_PAGE_URL
    },
    {
        name: 'About',
        route: ABOUT_PAGE_URL
    },
    {
        name: 'Domination',
        route: DOMINATION_SERVICES_PAGE_URL
    },
    {
        name: 'ABDL',
        route: ABDL_SERVICES_PAGE_URL
    },
]